import { API_USER_URL } from "@/env";
import { message } from "antd";
import { DefaultBankType } from "./type";

const API_USE = API_USER_URL || '';
type BankAccountAPI = {
    status: boolean;
    message?: string;
    data: DefaultBankType;
};

export async function getUserBankAccount(userId?: string): Promise<BankAccountAPI> {
    const token = localStorage.getItem('token') || '';
    if (!userId) {
        message.error('Người dùng không hợp lệ!');
        throw new Error('Invalid user');
    }
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/user-bank-accounts/${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching bank account data');
            throw new Error(`Error fetching bank account data: ${response.statusText}`);
        }
        const data = await response.json();
        if (!data.status) {
            message.error(data.message || 'Error fetching bank account data');
            throw new Error(`Error fetching bank account data: ${data.message}`);
        }
        return data as BankAccountAPI;
    } catch (error) {
        console.error('Failed to fetch bank account data:', error);
        throw error;
    }
}